"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    TabsEmphasisVariants: ()=>TabsEmphasisVariants,
    tabsEmphases: ()=>tabsEmphases,
    tabsVariants: ()=>tabsVariants
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const TabsEmphasisVariants = {
    regular: {
        tab: 'hover:bg-primary-3 active:bg-primary-4 text-primary-13 data-disabled:hover:bg-transparent data-disabled:active:bg-transparent data-disabled:text-primary-6 focus-visible:inset-ring-actionPrimary-12',
        indicator: 'bg-primary-8',
        panel: 'focus-visible:border-primary-8'
    },
    medium: {
        tab: 'hover:bg-primary-3 active:bg-primary-4 text-primary-13 data-disabled:hover:bg-transparent data-disabled:active:bg-transparent data-disabled:text-primary-6 focus-visible:inset-ring-actionPrimary-12',
        indicator: 'bg-primary-8',
        panel: 'focus-visible:border-primary-8'
    }
};
const tabsEmphases = Object.keys(TabsEmphasisVariants);
const tabsVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        root: 'relative overflow-x-hidden',
        list: 'relative z-0 flex w-full gap-1 overflow-x-auto pb-2',
        tab: 'focus-visible:inset-ring-2 focus-visible:inset-ring-offset-2 data-disabled:cursor-not-allowed group flex cursor-pointer select-none items-center justify-center rounded-lg px-3 py-2 focus-visible:outline-none',
        indicator: 'absolute bottom-0 left-0 z-[-1] h-1 w-[var(--active-tab-width)] -translate-y-1/2 translate-x-[var(--active-tab-left)] rounded-sm transition duration-200 ease-in-out',
        panel: 'focus-visible:border focus-visible:outline-none',
        tabLabelContent: 'flex flex-col items-start justify-center text-left'
    },
    variants: {
        emphasis: TabsEmphasisVariants
    },
    compoundVariants: [],
    defaultVariants: {
        emphasis: 'regular'
    }
});
exports.TabsEmphasisVariants = __webpack_exports__.TabsEmphasisVariants;
exports.tabsEmphases = __webpack_exports__.tabsEmphases;
exports.tabsVariants = __webpack_exports__.tabsVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "TabsEmphasisVariants",
    "tabsEmphases",
    "tabsVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
